import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { api, request } from '../../../../util/handlerRequestUtil'
import { Button } from 'primereact/button'
import { getMessage } from '../../../../util/IntlMessages'
import { notification } from 'antd'
import { columnsAlternativeAvailableList } from '../utils'

const AddAlternativeToGroup = ({ groupId, setModalDocumentVisible }) => {
  const [alternatives, setAlternatives] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  useEffect(() => {
    fetchAlternatives()
  }, [])

  const fetchAlternatives = async () => {
    const response = await request(api.findAvailableAlternatives(groupId), false, true)
    setAlternatives(response)
  }

  const addSelectedCustomersInGroup = async () => {
    const partnerDocumentIds = selectedRows.map((i) => i.id)
    let hasErrors = false

    for (const partnerDocumentId of partnerDocumentIds) {
      const data = { customerGroupId: groupId, partnerDocumentId: partnerDocumentId }
      try {
        await request(api.createCustomerDocuments(data))
      } catch (error) {
        hasErrors = true
        notification.error({
          description: getMessage('addAlternateError'),
          message: 'Erro'
        })
      }
    }

    if (!hasErrors) {
      notification.success({
        description: getMessage('addAlternateSuccess'),
        message: getMessage('sweetAlerts.success')
      })
    }

    setModalDocumentVisible(false)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <DataTable
        value={alternatives}
        selection={selectedRows}
        onSelectionChange={(e) => setSelectedRows(e.value)}
        responsiveLayout="scroll"
        selectionPageOnly
        first={0}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        scrollable
        scrollHeight="50vh"
        filterDisplay="row"
        responsive
        emptyMessage={getMessage('emptyCustomer')}
      >
        {columnsAlternativeAvailableList}
      </DataTable>
      <Button
        label={getMessage('addSelectedCustomers')}
        icon="pi pi-check"
        onClick={addSelectedCustomersInGroup}
        style={{ width: '40%', marginLeft: '60%', marginTop: 15 }}
      />
    </div>
  )
}

export default AddAlternativeToGroup
